import { call, put } from 'redux-saga/effects';

import {
    fetchApiSubscriptionsAPI,
    fetchRestApisListAPI,
    fetchUsagePlansListAPI,
    updateUsagePlanForApiAPI,
} from '../../apis';

import * as adminActions from '../actions';

/**
 * Fetch API subscriptions saga
 *
 * @method fetchApiSubscriptionsSaga
 * @type   {Generator}
 * @param  {Object} action The redux action (expects action.payload as params)
 * @return {Object}
 */
export function* fetchApiSubscriptionsSaga(action) {
    try {
        const { payload: params } = action;
        const response = yield call(fetchApiSubscriptionsAPI, params);
        const subscriptions = response?.data || {};
        yield put(adminActions.fetchApiSubscriptions.success(subscriptions));
        return subscriptions;
    } catch (error) {
        yield put(adminActions.fetchApiSubscriptions.error(error));
        return error;
    }
}

/**
 * Fetch API name List saga
 *
 * @method fetchRestApisListSaga
 * @type   {Generator}
 * @param  {Object} action The redux action (expects action.payload as params)
 * @return {Object}
 */
export function* fetchRestApisListSaga(action) {
    try {
        const {
            payload: { name },
        } = action;
        const response = yield call(fetchRestApisListAPI, { name });
        const restApisList = response?.data || {};
        yield put(adminActions.fetchRestApisList.success(restApisList));
        return restApisList;
    } catch (error) {
        yield put(adminActions.fetchRestApisList.error(error));
        return error;
    }
}

export function* fetchUsagePlansListSaga(action) {
    try {
        const { payload: params } = action;
        const response = yield call(fetchUsagePlansListAPI, params);
        const usagePlansList = response?.data || {};
        yield put(adminActions.fetchUsagePlansList.success(usagePlansList));
        return usagePlansList;
    } catch (error) {
        yield put(adminActions.fetchUsagePlansList.error(error));
        return error;
    }
}

export function* updateUsagePlanForApiSaga(action) {
    try {
        const { payload: updatedUsagePlanInfo } = action;
        const response = yield call(updateUsagePlanForApiAPI, updatedUsagePlanInfo);
        const updateUsagePlanResponse = response?.data || {};
        yield put(adminActions.updateUsagePlanForApi.success(updateUsagePlanResponse));
        return updateUsagePlanResponse;
    } catch (error) {
        yield put(adminActions.updateUsagePlanForApi.error(error));
        return error;
    }
}
